import Icon from '@commons/components/Icon';
import type { Template } from '@commons/components/RichText/templates';
import Flex from '@commons/containers/Flex';
import { Link } from '@commons/i18n/navigation';

/**
 * App Store Buttons CKEditor template.
 *
 * @returns A rendered React component.
 */

const StoreButtonsTemplate: Template = () => (
  <Flex gap={8} width={12} wrap="wrap">
    <Link href="https://apps.apple.com/in/app/codered/id1569880508" aria-label="App Store">
      <Icon type="appStore" />
    </Link>
    <Link
      href="https://play.google.com/store/apps/details?id=com.onsolve.codered"
      aria-label="Google Play"
    >
      <Icon type="googlePlay" />
    </Link>
  </Flex>
);

export default StoreButtonsTemplate;
